module.exports = __webpack_public_path__ + "static/media/hero.82c97351.mp4";